import React, { Component } from 'react';
import { Icon, Button } from 'react-materialize';

import EventUtils from '../../utils/EventUtils';
import StringUtils from '../../utils/StringUtils';

class SavedSearch extends Component {  
  render() {
    const { name, data } = this.props;

    return (
        <div className="saved-search">
            <div className="text-container">
              <h2 className="name">{ name.replace('_', StringUtils.SPACE) }</h2>
            </div>
            <div className="btn-container">
              <Button tooltip="Remove" onClick={ () => EventUtils.raiseEvent('delete', { name: name }, this.props) }>
                <Icon>highlight_off</Icon>
              </Button>
              <Button tooltip="Search" onClick={ () => EventUtils.raiseEvent('select', { name: name, search: data }, this.props) }>
                <Icon>search</Icon>
              </Button>
            </div>
        </div>
    );
  }
}

export default SavedSearch;